// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".oecp-md-category-tag[data-v-dd1d3cee]{display:inline-block;margin-right:10px;margin-bottom:10px}.oecp-md-category-tag .el-tag[data-v-dd1d3cee]{font-size:14px}.oecp_category_delete[data-v-dd1d3cee]{cursor:pointer}[data-v-dd1d3cee] .el-icon-close{font-size:18px}.el-tag--plain[data-v-dd1d3cee]{background-color:#edf2ff;border-color:#90afff;color:#497ee1;cursor:pointer}.el-tag--dark[data-v-dd1d3cee]{background-color:#73b9ff;border-color:#7399ff;color:#fff}", ""]);
// Exports
module.exports = exports;
